import { tracked } from '@glimmer/tracking';
import BillingItemMixin from 'client-portal/mixins/polymorphic/billing-item';
import Model, { attr, hasMany } from '@ember-data/model';

export default class SuperbillModel extends Model.extend(BillingItemMixin) {
  @hasMany('appointment', { async: false, inverse: 'superbill' }) appointments;
  @attr() displayName;
  @attr('moment') createdAt;
  @attr() totalAmount;
  @attr() isNewForClient;

  get isUnread() {
    return !this.opened && this.isNewForClient;
  }

  // Tracked so `isUnread` recomputes when `billing-modals` marks the superbill
  // as opened (via `model.set('opened', true)`); matches receipt.js.
  @tracked opened = false;
}
